import React from 'react';
import Text from '@amzn/meridian/text';
import Column from '@amzn/meridian/column';
import Breadcrumb, { BreadcrumbGroup } from '@amzn/meridian/breadcrumb';
import Responsive from '@amzn/meridian/responsive';
import ContainerDetails from 'src/components/common/container-details/ContainerDetails';
import UILoader from 'src/components/common/loader/UILoaderContainer';
import { ContainerDetailsModel } from 'src/components/common/container-details/ContainerDetailsModel';
import { SearchIcons } from 'src/constants/general-media';
import './Identification.scss';
import * as AppStrings from 'src/localization/string-ids/app-strings';
import * as AppRoutes from 'src/routing/constants/routes';
import { responsiveProps } from 'src/constants/responsiveProps';
import { buildGetContainerDetailsInput, GetContainerDetailsInput, GetContainerMode } from 'src/models/GetContainerDetails';
import StatusAlert from 'src/components/common/status-alert/StatusAlertContainer';
import SearchInput from 'src/components/common/search-input/SearchInput';


interface IdentificationProps {
    containerDetails?: ContainerDetailsModel;
    warehouseId: string;
    associate: string;
    locale: string;
    fetchContainerDetails: (getContainerDetailsInput: GetContainerDetailsInput) => void;
    resetContainerState: () => void;
}

class Identification extends React.Component<IdentificationProps> {

    private onSearchSubmit = async (containerId: string) => {
        await this.props.fetchContainerDetails(buildGetContainerDetailsInput(containerId,
                    this.props.warehouseId, this.props.associate, this.props.locale,
                    GetContainerMode.IDENTIFICATION));
    };

    public render() {
        return (
            <Responsive query={"max-width"} props={responsiveProps}>
                {props => (
                    <Column className="identification">
                        <BreadcrumbGroup>
                            <Breadcrumb href={AppRoutes.HOME_PAGE_ROUTE}>{AppStrings.HOME}</Breadcrumb>
                            <Breadcrumb>{AppStrings.IDENTIFICATION}</Breadcrumb>
                        </BreadcrumbGroup>
                        {!this.props.containerDetails &&
                            <Column alignmentHorizontal="center">
                                <img src={SearchIcons.SEARCH_MAGNIFYING_GLASS} alt="Search Icon"
                                     className="identification-icon"/>
                                <Text type={props.titleSize} data-testid="identification-heading">{AppStrings.IDENTIFICATION_CENTER_TEXT}</Text>
                            </Column>
                        }
                        <SearchInput
                            searchFieldLabel={AppStrings.IDENTIFICATION_SEARCHFIELD_LABEL}
                            searchFieldPlaceholder={AppStrings.IDENTIFICATION_SEARCHFIELD_PLACEHOLDER}
                            renderSearchButton={true}
                            onSubmit={this.onSearchSubmit}
                            data-testid="identification-search-input"
                        />
                        <UILoader/>
                        <StatusAlert/>

                        {this.props.containerDetails &&
                            <ContainerDetails containerDetails={this.props.containerDetails}
                                              tableTestId="identification-results-table"/>
                        }
                    </Column>
                )}
            </Responsive>
        );
    }

    componentWillUnmount() {
        this.props.resetContainerState();
    }
}

export default Identification;
